import dateUtils from './date.utils';

const toDate = (value) => {
  if (value instanceof Date) return value;
  if (!value) return undefined;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

/**
 * Converts FullCalendar EventApi values and plain scheduler events to one callback shape.
 */
const toSchedulerEvent = (eventData) => {
  if (!eventData) return null;

  const extendedProps = eventData.extendedProps || {};
  const start = toDate(eventData.start);
  const end = toDate(eventData.end);
  const schedulerEvent = {
    id: eventData.id,
    title: eventData.title,
    start,
    end,
    extendedProps,
  };

  if (eventData.allDay !== undefined) schedulerEvent.allDay = eventData.allDay;
  if (eventData.description !== undefined) schedulerEvent.description = eventData.description;
  if (start) schedulerEvent.startTimestamp = dateUtils.getTemporalPlainDateTime(start);
  if (end) schedulerEvent.endTimestamp = dateUtils.getTemporalPlainDateTime(end);

  return schedulerEvent;
};

export default toSchedulerEvent;
